import { render, staticRenderFns } from "./AIChatWidgetReferenceImagesPicker.vue?vue&type=template&id=59f63521&scoped=true"
import script from "./AIChatWidgetReferenceImagesPicker.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetReferenceImagesPicker.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetReferenceImagesPicker.vue?vue&type=style&index=0&id=59f63521&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f63521",
  null
  
)

export default component.exports